import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom'
import axios from 'axios';

interface Props {
    onDataReceived: (data: object) => void
    formTypeId: string
    companyId: string
    quarterId: string
    disabled: boolean
}

const API_URL = process.env.REACT_APP_API_URL

export const SpreadsheetFileUpload: React.FC<Props> = ({ onDataReceived, formTypeId, companyId, quarterId, disabled }) => {
    const [spreadsheet, setSpreadsheet] = useState<File | null>(null);

    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const selectedFile = event.target.files?.[0] || null;
        setSpreadsheet(selectedFile);

    };
    useEffect(() => {
        if (spreadsheet)
            handleUpload()
    }, [spreadsheet]);

    const handleUpload = async () => {
        if (!spreadsheet) {
            return;
        }

        const formData = new FormData();
        formData.append('spreadsheet', spreadsheet);
        formData.append('formTypeId', formTypeId as any);
        formData.append('companyId', companyId as any);
        formData.append('quarterId', quarterId as any);

        try {
            const response = await axios.post(`${process.env.REACT_APP_API_URL}/bm/CollectionsDetail/spreadsheetSubmit`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            onDataReceived(response.data);
        } catch (error: any) {
            //Error
        }
    };

    return (
        <div>
            <input className="form-control form-control-lg" id="formFileLg" disabled={disabled} type="file" onChange={handleFileChange} />
        </div>
    );
};

